function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import { arrayOf, func, shape, string } from "prop-types";
import { components } from "react-select";
import { MultiValueRemove } from "#library/components/SelectFilter/customComponents/MultiValueRemove/MultiValueRemove";
var MultiValue = components.MultiValue,
  MultiValueContainer = components.MultiValueContainer,
  MultiValueLabel = components.MultiValueLabel;
export var MultiValueCustom = function MultiValueCustom(props) {
  var selectedValues = props.selectedValues,
    setValue = props.setValue;
  var deselectOption = function deselectOption(option) {
    setValue(selectedValues.filter(function (currentOptions) {
      return currentOptions.value !== option.value;
    }), "deselect-option", option);
  };
  var getValues = function getValues(selectValue) {
    return selectValue.map(function (opt, index) {
      var key = "".concat(opt.label, "-").concat(opt.value);
      return /*#__PURE__*/React.createElement(MultiValue, _extends({}, props, {
        components: {
          Container: MultiValueContainer,
          Label: MultiValueLabel,
          Remove: MultiValueRemove
        },
        isFocused: false,
        isDisabled: false,
        key: key,
        index: index,
        removeProps: {
          onClick: function onClick() {
            return deselectOption(opt);
          },
          onTouchEnd: function onTouchEnd() {
            return deselectOption(opt);
          },
          onMouseDown: function onMouseDown(event) {
            event.preventDefault();
            event.stopPropagation();
          }
        },
        data: opt
      }), opt.label);
    });
  };
  return getValues(selectedValues);
};
MultiValueCustom.propTypes = {
  selectedValues: arrayOf(shape({
    value: string
  })).isRequired,
  setValue: func.isRequired
};